import { Link } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { MAIN_CONTENT_ID } from "routes/@layouts/app/main-style"
import { isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_SIDE_NAV_REDESIGN } from "routes/@layouts/app/navbar/feature-flag-side-nav-redesign.runtime"

export function SkipLink() {
    const theme = useTheme()

    if (!isEnabled(FEATURE_FLAG_SIDE_NAV_REDESIGN)) return null

    return (
        <Link
            href={`#${MAIN_CONTENT_ID}`}
            underline="none"
            onClick={focusMainContent}
            sx={{
                position: "fixed",
                top: 8,
                left: 8,
                zIndex: 4100,
                px: 2,
                py: 1.25,
                borderRadius: 1,
                bgcolor: "background.paper",
                color: "text.primary",
                typography: "subtitle2",
                boxShadow: theme.customShadows?.z8 ?? theme.shadows[8],
                transform: "translateY(calc(-100% - 16px))",
                "&:focus": {
                    transform: "translateY(0)",
                    outline: `2px solid ${theme.palette.primary.main}`,
                    outlineOffset: 2,
                },
            }}
        >
            Skip to main content
        </Link>
    )

    function focusMainContent(event) {
        const main = document.getElementById(MAIN_CONTENT_ID)
        if (!main) return
        event.preventDefault()
        main.focus()
    }
}
